module.exports = __webpack_public_path__ + "static/media/комната гг 3.e77a1126.jpg";